import api from "@/lib/api";

// Ask which month repayments should start; defaults to the next payroll run. Returns "YYYY-MM" or null.
export async function askDeductionStart(prompt, loan, fmt) {
    let suggested = "";
    try {
        const { data } = await api.get("/loans/next-deduction-period");
        suggested = data.period;
    } catch {
        suggested = "";
    }
    const requested = loan.start_period || "";
    const isAdvance = (loan.type || "loan") === "advance";
    const value = await prompt({
        title: `Disburse ${loan.employee_name}'s ${isAdvance ? "advance" : "loan"}?`,
        description: `${fmt(loan.amount)}. Pick the payroll month the ${isAdvance ? "deduction" : "repayments"} should start — any month whose payroll isn't finalised yet. Suggested${suggested ? `: ${suggested}` : " month is the next open payroll"}. Draft payrolls for that month update automatically.`,
        inputType: "month",
        defaultValue: requested > suggested ? requested : suggested,
        required: true,
        confirmLabel: "Mark disbursed",
    });
    return value === null ? null : value.trim();
}
